import AlertNotification from './AlertNotification';
import InfoNotification from './InfoNotification';
import ConfirmNotification from './ConfirmNotification';
import { SystemNotification } from "./SystemNotification";

class Notification {

  constructor({ model, socket = null }) {
    new AlertNotification({model, socket});
    new InfoNotification({model, socket});
    new ConfirmNotification({model, socket});

    const systemNotification = new SystemNotification({ model, socket });
    if ($('.world-top-nav__logo_area').length) {
      systemNotification.attachTo('.world-top-nav__logo_area');
    } else {
      systemNotification.attachTo('body');
      systemNotification.activeFloatingMode();
    }
  }

}

export default Notification;
